import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { hoverEffect } from '../hoverEffect';

export const TextButton = ({ children, onClick, className }) => (
  <button
    type="button"
    onClick={onClick}
    css={css`
      color: inherit;
      cursor: pointer;
      background: transparent;
      text-decoration: underline;
      padding: 0;
      margin: 0;
      outline: 0;
      border: none;

      &:hover {
        color: inherit;
      }
      ${hoverEffect}
    `}
    className={className}
  >
    {children}
  </button>
);

TextButton.defaultProps = {
  onClick: () => {},
  className: '',
};

TextButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
};
